import {
  AdjustmentsHorizontalIcon,
  AdjustmentsVerticalIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowDownRightIcon,
  NoSymbolIcon,
  BellIcon,
  CakeIcon,
  CalendarIcon,
  CheckIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  ArrowDownTrayIcon,
  ExclamationTriangleIcon,
  ExclamationCircleIcon,
  EyeIcon,
  EyeSlashIcon,
  HandRaisedIcon,
  HomeIcon,
  InformationCircleIcon,
  MapPinIcon,
  ArrowLeftEndOnRectangleIcon,
  ArrowLeftStartOnRectangleIcon,
  EnvelopeIcon,
  Bars3Icon,
  PaperAirplaneIcon,
  PlusIcon,
  PencilIcon,
  PhoneIcon,
  ArrowUturnLeftIcon,
  MagnifyingGlassIcon,
  SparklesIcon,
  TicketIcon,
  TrashIcon,
  Bars4Icon,
  UserGroupIcon,
  UsersIcon,
  UserIcon,
  QrCodeIcon,
  XCircleIcon,
  XMarkIcon,
  MinusIcon,
  LightBulbIcon,
  ArrowTopRightOnSquareIcon,
  LinkIcon,
  CalendarDateRangeIcon,
  LockOpenIcon
} from "@heroicons/react/24/outline";

import {
  PlayIcon,
  LockClosedIcon,
  ComputerDesktopIcon,
  EllipsisHorizontalIcon
} from "@heroicons/react/24/solid";

export const Icons = {
  Adjustments: AdjustmentsHorizontalIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  ArrowDownRightIcon: ArrowDownRightIcon,
  ArrowTopRightOnSquareIcon: ArrowTopRightOnSquareIcon,
  Ban: NoSymbolIcon,
  Bell: BellIcon,
  Cake: CakeIcon,
  Calendar: CalendarIcon,
  CalendarDateRangeIcon: CalendarDateRangeIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  ChevronDown: ChevronDownIcon,
  ChevronLeft: ChevronLeftIcon,
  ChevronRight: ChevronRightIcon,
  Clock: ClockIcon,
  DesktopComputer: ComputerDesktopIcon,
  DotsHorizontal: EllipsisHorizontalIcon,
  Download: ArrowDownTrayIcon,
  Exclamation: ExclamationTriangleIcon,
  ExclamationCircle: ExclamationCircleIcon,
  Eye: EyeIcon,
  EyeOff: EyeSlashIcon,
  Hand: HandRaisedIcon,
  Home: HomeIcon,
  InformationCircle: InformationCircleIcon,
  LinkIcon: LinkIcon,
  LightBulb: LightBulbIcon,
  LocationMarker: MapPinIcon,
  LockClosed: LockClosedIcon,
  LockOpen: LockOpenIcon,
  Login: ArrowLeftEndOnRectangleIcon,
  Logout: ArrowLeftStartOnRectangleIcon,
  Mail: EnvelopeIcon,
  Menu: Bars3Icon,
  Minus: MinusIcon,
  PaperAirplane: PaperAirplaneIcon,
  Phone: PhoneIcon,
  Play: PlayIcon,
  Plus: PlusIcon,
  Pencil: PencilIcon,
  Reply: ArrowUturnLeftIcon,
  Search: MagnifyingGlassIcon,
  Sparkles: SparklesIcon,
  Ticket: TicketIcon,
  Trash: TrashIcon,
  UserGroup: UserGroupIcon,
  Users: UsersIcon,
  User: UserIcon,
  ViewList: Bars4Icon,
  Qrcode: QrCodeIcon,
  XCircle: XCircleIcon,
  X: XMarkIcon,
};